import React from "react";
import baseUrl from "constants/baseUrl.js";
import { Store } from "public-components/StoreProvider";

const useAuthScripts = () => {
  const { dispatch } = React.useContext(Store);
  const [hasInjectedScripts, setHasInjectedScripts] = React.useState(false);

  React.useEffect(() => {
    if (hasInjectedScripts) return;

    // 埋点代码
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-5763HM");

    const paymentScript = document.createElement("script");
    paymentScript.onload = function() {
      window.FotorCommon = function() {};
      window.FotorCommon.Analytic = function() {};
      window.FotorCommon.Analytic.transaction = function() {};
      window.FotorCommon.LeftInfo = {};
      window.FotorCommon.LeftInfo.setLeftInfo = function() {};
      window.FotorCommon.User = {};
      dispatch({ type: "SCRIPT_LOADED" });
    };

    if (process.env.SERVER_ENV === "production") {
      paymentScript.src =
        "https://pub-static.haozhaopian.net/static/web/payment/app.a1fd3c01.js?v1";
    } else {
      paymentScript.src =
        "https://test-static.haozhaopian.net/static/web/payment/app.ce73e36f.js?v1";
    }

    document.head.appendChild(paymentScript);

    // 更改登录代码设置
    window["GATEWAY_URL"] = baseUrl;
    window["UNIVERSAL_VERSION"] = true;

    // 确认脚本已插入
    setHasInjectedScripts(true);
  }, [hasInjectedScripts, dispatch]);
};

export default useAuthScripts;
